import { CommonService } from '../../common.service';
import {
    Injectable
} from '@angular/core';
import { SharedService } from '../../shared.service';
import Utils from 'src/app/utils';
import { ApplicationService } from 'src/app/application.service';
@Injectable()
export class SearchFilterDataService {

    dropdownKeys = ['Update On', 'node type', 'taxonomies', 'updated by',
        'Projects', 'Adoption Status', 'Item Association Type', 'Workflow']; // holds the list of dropdown keys //'updated by',
    inputForFilter = []; // holds entire list of filter dropdown contents (all filter flat array)
    dropdownObject = {}; // holds the entire dropdown object

    loadedFilters = {
        'Update On': false,
        'node type': false,
        taxonomies: false,
        'updated by': false,
        'Adoption Status': false,
        'Item Association Type': false,
        projects: false,
        workflows: false
    }; // holds boolean if filter is loaded

    constructor(private service: CommonService, private sharedService: SharedService,
        private applicationService: ApplicationService) { }




    /* ---------Generate dropdown object functionality Start --------- */

    createStaticDropdownObj() {
        this.dropdownKeys.forEach(key => {
            this.dropdownObject[key] = [];
            this.inputForFilter.forEach(obj => {
                if (obj.element === key) {
                    this.dropdownObject[key].push(obj);
                }
            });
        });
        return this.dropdownObject;
    }

    /* ---------Generate dropdown object functionality End --------- */






    /* --------- Functionality to fetch all node types start --------- */

    async getAllNodeTypes() {
        const data: any = await this.applicationService.getApplicationServiceData(
            true,
            'nodeTypeList'
        );
        data?.nodetype.forEach(element => {
            this.inputForFilter.push({
                filter_type: 'node_type_id',
                filter_value: element.node_type_id,
                label: element.title,
                is_selected: 0,
                filter_key: '',
                element: 'node type'
            });
        });
        this.loadedFilters['node type'] = true;
        this.emitFilterLoadedEvent('node type', data);
    }

    /* --------- Functionality to fetch all node types end --------- */



    /* --------- Functionality to fetch all users start --------- */

    async getUsers() {
        const data: any = await this.applicationService.getApplicationServiceData(
            true,
            'usersList'
        );
        data?.UserList.users.forEach(element => {
            this.inputForFilter.push({
                filter_type: 'updated_by',
                filter_value: element.user_id,
                label: element.first_name,
                is_selected: 0,
                filter_key: '',
                element: 'updated by'
            });
        });
        this.loadedFilters['updated by'] = true;
        this.emitFilterLoadedEvent('updated by', data);
    }

    /* --------- Functionality to fetch all users end --------- */

    /* --------- Functionality to fetch updated on duration start --------- */

    updateOn() {
        this.inputForFilter.push({
            filter_type: 'update_on',
            filter_value: 'today',
            label: 'today',
            is_selected: 0,
            filter_key: '',
            element: 'Update On'
        }, {
            filter_type: 'update_on',
            filter_value: 'last_seven_days',
            label: 'last seven days',
            is_selected: 0,
            filter_key: '',
            element: 'Update On'
        }, {
            filter_type: 'update_on',
            filter_value: 'last_thirty_days',
            label: 'last thirty days',
            is_selected: 0,
            filter_key: '',
            element: 'Update On'
        });
        this.loadedFilters['Update On'] = true;
        this.emitFilterLoadedEvent('Update On', []);
    }

    /* --------- Functionality to fetch updated on duration end --------- */

    /* --------- Functionality to fetch all project start --------- */

    async getProjects() {
        const data: any = await this.applicationService.getApplicationServiceData(false, 'projectTypeList', '?project_type=1');
        data?.projects.forEach(element => {

            this.inputForFilter.push({
                filter_type: 'project_id',
                filter_value: element.project_id,
                label: Utils.extractContentFromHtml(element.project_name),
                is_selected: 0,
                filter_key: '',
                element: 'Projects'
            });

        });
        this.loadedFilters.projects = true;
        this.emitFilterLoadedEvent('Projects', data);
    }

    /* --------- Functionality to fetch all project end --------- */


    /* --------- Functionality to fetch all taxonomies start --------- */

    async listTaxonomies() {
        const data: any = await this.applicationService.getApplicationServiceData(false, 'taxonomyTypeList');
        data?.forEach(element => {
            this.inputForFilter.push({
                filter_type: 'document_id',
                filter_value:element.document_id,
                filter_source_value: element.source_document_id,
                label: Utils.extractContentFromHtml(element.title),
                is_selected: 0,
                filter_key: '',
                element: 'taxonomies',
                import_type: element.import_type
            });
        });
        this.loadedFilters.taxonomies = true;
        this.emitFilterLoadedEvent('taxonomies', data);
        return data;
    }

    /* --------- Functionality to fetch all taxonomies end --------- */

    /* --------- Functionality to add all Adoption Status start --------- */

    fillAdoptionStatus() {
        this.inputForFilter.push({
            filter_type: 'adoption_status',
            filter_value: 'Draft',
            label: 'Draft',
            is_selected: 0,
            filter_key: '',
            element: 'Adoption Status',
            type: 'value'
        }, {
            filter_type: 'adoption_status',
            filter_value: 'Adopted',
            label: 'Adopted',
            is_selected: 0,
            filter_key: '',
            element: 'Adoption Status',
            type: 'value'
        }, {
            filter_type: 'adoption_status',
            filter_value: 'Deprecated',
            label: 'Deprecated',
            is_selected: 0,
            filter_key: '',
            element: 'Adoption Status',
            type: 'value'
        });
        this.loadedFilters['Adoption Status'] = true;
        this.emitFilterLoadedEvent('Adoption Status', []);
    }

    /* --------- Functionality to add all Adoption Status end --------- */

    /* --------- Functionality to fetch all association types start --------- */

    async getAssociationType() {
        if (Utils.getCookie('central_auth_token')) {
            const data: any = await this.applicationService.getApplicationServiceData(true, 'associationTypeAll', '?type=all');
            data?.forEach(element => {
                if (element.type_name !== 'exemplar') {
                    this.inputForFilter.push({
                        filter_type: 'item_association_type',
                        filter_value: element.type_id,
                        label: element.display_name,
                        is_selected: 0,
                        filter_key: '',
                        element: 'Item Association Type',
                        type: 'value',
                        case_custom_association_type: element.case_custom_association_type
                    });
                }
            });
            this.loadedFilters['Item Association Type'] = true;
            this.emitFilterLoadedEvent('Item Association Type', data);
        }
    }

    /* --------- Functionality to fetch all association types end --------- */

    /* --------- Functionality to fetch all workflow start --------- */

    async getWorkFlowDetails() {
        const data: any = await this.applicationService.getApplicationServiceData(false, 'workflowList');
        data?.WorkflowList.workflows.forEach(element => {
            this.inputForFilter.push({
                filter_type: 'project_workflow_id',
                filter_value: element.workflow_id,
                label: element.name,
                is_selected: 0,
                filter_key: '',
                element: 'Workflow',
                type: 'value'
            });
        });
        this.loadedFilters.workflows = true;
        this.emitFilterLoadedEvent('Workflow', data);
    }
    /* --------- Functionality to fetch all workflow start --------- */

    emitFilterLoadedEvent(label, response) {
        this.sharedService.searchFiltersLoaded.next({
            loadedFilters: this.loadedFilters,
            key: label,
            data: response
        });
    }

    /* --------- Functionality to clear raw array holding filter data start --------- */

    clearFilterArray() {
        this.inputForFilter = [];
    }

    /* --------- Functionality to clear raw array holding filter data end --------- */
}
